import Cookies from 'universal-cookie';
import { COOKIE_NAMES } from 'lib/enums/cookies';

const getOptimizelyUserId = (): string | null => {
  const cookies = new Cookies();

  return cookies.get(COOKIE_NAMES.OPTIMIZELY_USER_ID) || null;
};

export default getOptimizelyUserId;
